import axios from 'axios';
import {logMessage} from '../components/utils.js';
import {
    getSessKey,
    gcmEncrypt,
    gcmDecrypt,
    generateBearerTokenKey
} from '../crypto/msgCrypto';

import { generateEcdhKeys } from '../crypto/ecdhCrypto';
import Config from '../config';
import { getUserDetail, setLogout } from '../hooks/handleUserLocalStorage.js';



let expiredTimer = null;
const axiosInstance = axios.create({
    baseURL: Config.baseURL,
    headers: {
        'Content-Type': 'application/octet-stream'
        // Authorization: `Bearer asdasd`
    },
    timeout: 30000, // Set timeout to 30 seconds
});

axiosInstance.interceptors.request.use(
    function (config) {
        logMessage("axios request:["+config.method+"] ",config.url)
        let method = config.method;
        let userDetail = getUserDetail();

        //AES encryption with ECDH sharedKey
        //encrypt body data
        //generate ECDH Key
        let { sharedKey, publicKey } = generateEcdhKeys();
        config.ECDHPublicKey = publicKey;
        config.ECDHSharedKey = sharedKey;

        if (method == 'get') {
            //get
            let encryptedBody = gcmEncrypt('{}', sharedKey);
            config.data = encryptedBody;
        } else {
            //post
            //let encryptedBody = gcmEncrypt(config.data, sharedKey);

            // let encryptedBody = '';

            if (userDetail && userDetail.token) {
                let token = userDetail.token;
                let key = getSessKey(token);

                let encryptedBody = gcmEncrypt(config.data, key);

                config.data = encryptedBody;
            } else {
                let encryptedBody = gcmEncrypt(config.data, sharedKey);

                config.data = encryptedBody;
            }
        }

        if (userDetail && userDetail.token) {
            let token = userDetail.token;
            //protected api
            config.headers['Authorization'] = `Bearer ${token}`;
            // config.headers['Ecdh-Public-Key'] = publicKey;
        } else {
            //public api
            config.headers['Ecdh-Public-Key'] = publicKey;
        }

        return config;
    },
    function (error) {

        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        if (response.status === 200 && response.data) {
            // logMessage('response?.headers', response?.headers);
            // let headers = response?.headers;
            // let expiredAt = headers['expired-at'];
            // let endDate = moment(expiredAt);
            // logMessage(moment(expiredAt).format('YYYY-MM-DD hh:mm:ss'));

            // let duration = moment.duration(endDate.diff(moment()), 'minutes');
            // logMessage("duration",duration)

            // let test = endDate.fromNow()
            // logMessage("test",test)

            // logMessage("reset timer")
            // clearTimeout(expiredTimer);
            // expiredTimer = setTimeout(function () {
            //     alert('timeout');
            // }, 5000);

            return response; //fetch data to display
        } else {
            alert(response.status);
            alert('Warning: Fail to get data. ' + response.data.message);
        }
    },
    (error) => {
  
        if (error.code === 'ECONNABORTED') {
            console.log('Request timed out');
     
            if(error.config.url === "/sess/logout"){
                console.log("trigger error logout");
                setLogout();
                window.location.href = './';
            }
          }

        //logMessage(error);

        //handle with WithAxios.js
        if (error.response.status === 401) {

            // let userDetail = getUserDetail();
            // if (userDetail && userDetail.token) {
            //     alert('Session expired');
            // }
            //setLogout();
            // window.location.href = './';
        } 
        // else if (error.response.status === 500) {
        //     showNotiLoaderError();
        // }

        //----throw error to WithAxios.ts----//
        throw error
    }
);

//used to call api
const handleRequestPost = async (url, param,recaptchaToken=null) => {
    //stringify param before going to next step
    let stringifyBody = JSON.stringify(param);
    // logMessage('stringifyBody');
    // logMessage(param);

    const headers = {
        ...(recaptchaToken ? { 'X-Recaptcha-Token': recaptchaToken } : {}),
    };


    return axiosInstance
        .post(url, stringifyBody, { headers })
        .then(async function (response) {
            // handle success
            // logMessage(response);
            if (response) {
                let status = response.status;

                if (status == 200) {
                    let data = response.data;
                    let userDetail = getUserDetail();

                    //logined
                    if (userDetail && userDetail.token) {
                        let token = userDetail.token;
                        // logMessage("token")
                        // logMessage(token)
                        let key = await generateBearerTokenKey(token);

                        // logMessage('token', token);
                        // logMessage('key', key);
                        let result = await gcmDecrypt(data, key);
                        // logMessage('gcmDecrypt result', result);
                        return result;
                    } else {
                        const { config } = response;
                        //get sharedkey from config
                        let ECDHSharedKey = config.ECDHSharedKey;
                        let result = await gcmDecrypt(data, ECDHSharedKey);
                        
                        return result;
                    }
                } else {
                    alert('Request Failed');
                }
            }
        })
        .catch(function (error) {
            // handle error
            logMessage(error);


        });
};

const handleRequestPut = async (url, param) => {
    //stringify param before going to next step
    let stringifyBody = JSON.stringify(param);
    // logMessage('stringifyBody');
    // logMessage(param);
    return axiosInstance
        .put(url, stringifyBody)
        .then(async function (response) {
            // handle success
            // logMessage(response);
            if (response) {
                let status = response.status;

                if (status == 200) {
                    let data = response.data;
                    let userDetail = getUserDetail();

                    //logined
                    if (userDetail && userDetail.token) {
                        let token = userDetail.token;
                        // logMessage("token")
                        // logMessage(token)
                        let key = await generateBearerTokenKey(token);

                        // logMessage('token', token);
                        // logMessage('key', key);
                        let result = await gcmDecrypt(data, key);
                        // logMessage('result', result);
                        return result;
                    } else {
                        const { config } = response;
                        //get sharedkey from config
                        let ECDHSharedKey = config.ECDHSharedKey;
                        let result = await gcmDecrypt(data, ECDHSharedKey);

                        return result;
                    }
                } else {
                    alert('Request Failed');
                }
            }
        })
        .catch(function (error) {
            // handle error
            logMessage(error);
        });
};


const handleRequestGet = async (url, param,fullReponse = false) => {
    //stringify param before going to next step
    let stringifyBody = JSON.stringify(param);
    return axiosInstance
        .get(url, stringifyBody)
        .then(async function (response) {
            if (response) {
                let status = response.status;

                if (status == 200) {
                    let data = response.data;
                    let userDetail = getUserDetail();

                    if (userDetail && userDetail.token) {
                        let token = userDetail.token;
                        let key = await generateBearerTokenKey(token);
                        let result = await gcmDecrypt(data, key);
                        // logMessage(key);
                        // logMessage(result);
                        //logMessage("gcmDecrypt ",result);
                        
                        if(fullReponse == true)
                        {
                            response.data = result;
                            return response
                        }else{
                            return result;
                        }
                        
                    } else {
                        const { config } = response;
                        //get sharedkey from config
                        let ECDHSharedKey = config.ECDHSharedKey;
                        let result = await gcmDecrypt(data, ECDHSharedKey);
                     
                        return result;
                    }
                } else {
                    alert('Request Failed');
                }
            }
        })
        .catch(function (error) {

            // handle error
            logMessage(error);
        
        });
};

export { handleRequestPost,handleRequestPut, handleRequestGet, axiosInstance };
